<template>
    <header class="navigation">
        <nav class="flex flex-wrap items-start justify-between">
            <div class="flex-none pr-2">
                <img class="block h-8 ml-5 md:ml-10 mt-5 md:mt-12 cursor-pointer" src="../assets/halsa-logo.png"
                    alt="Logo" @click="router.push('/')">
            </div>

            <div class="flex items-center h-8 mt-5 md:mt-12 md:mr-10">
                <router-link :to="{ name: 'discussions' }" class="nav-link text-gray-500 text-sm mr-4 hover:text-green"
                    active-class="nav-link--active">
                    {{ $t('default.navigation.discussions') }}
                </router-link>
                <LocaleChanger class="flex-1"></LocaleChanger>
                <router-link :to="{ name: 'userResults', params: { usr: user.id } }"
                    class="flex-1 login-status text-gray-500 text-sm mr-3 ml-6"
                    v-if="user && Object.keys(user).length > 0">
                    {{ user.first_name || user.username }}
                </router-link>
                <img class="cursor-pointer ml-0" src="../assets/svg/logout.svg" alt="logout" @click="logout">
            </div>

            <div class="w-full flex flex-wrap items-center px-5 md:px-10 mt-4 md:mt-8">
                <NavigationHierarchy class="flex-1 min-w-0 mr-4"></NavigationHierarchy>
                <MaterialPageNavigation v-if="showMaterialNavigation" class="ml-auto mb-3"
                    :navigation="materialPage.navigation"></MaterialPageNavigation>
            </div>
        </nav>
    </header>
</template>

<script setup>
import LocaleChanger from '@/components/LocaleChanger'
import NavigationHierarchy from './NavigationHierarchy'
import { computed } from 'vue'
import { useStore } from 'vuex'
import MaterialPageNavigation from '@/components/material-bank/MaterialPageNavigation.vue'
import { useRouter, useRoute } from 'vue-router'

const store = useStore()
const router = useRouter()
const route = useRoute()

const materialPage = computed(() => store.state.materialBank?.currentPage)
const showMaterialNavigation = computed(
    () => route.name === 'materialBankPage' && !!materialPage.value
)

const user = computed(() => store.state.user.user)

const logout = () => store.dispatch('user/logout')
</script>

<style scoped>
.navigation {
    max-width: 1600px;
    margin: 0 auto;
    width: 100%;
}


.nav-link {
    white-space: nowrap;
}

.nav-link--active {
    color: var(--halsa-green) !important;
    font-weight: 700;
}

@media screen and (max-width: 500px) {
    .navigation {
        padding-right: 0;
    }
}
</style>
